//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 export default {
  props:['zong'],
  data() {
   return {
    orderNum: ['0', '0', '0'], // 默认订单总数
    dqNum:0,
    timer:''
   }
  },
  created(){
	   this.dangqian()
  },
  destroyed(){
  	clearInterval(this.timer)
  },
  watch:{
    zong:{
				handler(val,old){
				 this.dangqian();
				},
				deep:true,
				immediate: true
			}
    },
  mounted(){
	  var that=this;var num=34;
		// that.toOrderNum(that.dqNum) // 这里输入数字即可调用
   	 that.timer=setInterval(() => {
        that.dangqian() // 这里输入数字即可调用
      },60*1000);
  },
  methods: {
	  dangqian(){
				var arr=[25,26,27,28,29,30]
				this.dqNum=this.zong
				this.toOrderNum(this.zong)
	  },
    // 设置文字滚动
   setNumberTransform () {
    const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
    const numberArr = this.orderNum.filter(item => !isNaN(item))
    // 结合CSS 对数字字符进行滚动,显示订单数量
    for (let index = 0; index < numberItems.length; index++) {
    const elem = numberItems[index]
    elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
    }
   },
   // 处理总订单数字
   toOrderNum(num) {
    num = num.toString()
    // 把订单数变成字符串
    if (num.length < 3) {
    num = '0' + num // 如未满八位数，添加"0"补位
    this.toOrderNum(num) // 递归添加"0"补位
    } else if (num.length === 3) {
    // 订单数中加入逗号
    // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
    this.orderNum = num.split('') // 将其便变成数据，渲染至滚动数组
    } else {
    // 订单总量数字超过八位显示异常
    // this.$message.warning('订单总量数字过大，显示异常，请联系客服')
    }
	// this.setNumberTransform ()
   },
  }
 }



// WEBPACK FOOTER //
// ./src/components/test1.vue